var scope_0 = require('/Users/dshanley/development/camel/content-camel-docs/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/285ffeaaa4cbda96f1668019e4c57893.js').default;export default
        Object.assign({}, scope_0 )
    